// extracted by mini-css-extract-plugin
export default {"background":"GameBG_background__h6XY2","img":"GameBG_img__d2ze7"};